@if (!showForm) {
	<div (click)="toggleShowForm()">
		<span nz-icon nzType="plus-circle" nzTheme="outline"></span>
		<span class="title">Enroll in new class</span>
	</div>
}

@if (showForm) {
	<div>
		@if (loading) {
			<nz-spin nzSimple nzSize="large"></nz-spin>
		}
		@if (!loading) {
			<input nz-input placeholder="Class Code" [(ngModel)]="sectionCode" />
			<button nz-button (click)="addSection(); $event.preventDefault()" title="Save" class="save">
				<span nz-icon nzType="save" nzTheme="outline"></span>
				Save
			</button>
			<button nz-button (click)="toggleShowForm(); $event.preventDefault()" title="cancel">cancel</button>
		}
	</div>
}
